import React from 'react'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import { CaretUpOutlined, CaretDownOutlined } from '@ant-design/icons'
import { Modal } from 'antd'
import intl from 'react-intl-universal'
import { changeLanguage } from '@/services/login'
import user from '@/utils/user'
import login from '@/utils/login'

dayjs.extend(duration)
/**
 * 转换为 2018-1-1 00:00:00 和 2018-1-1 23:59:59 格式
 * @param date
 * @param isStart 是否为开始时间，否则为结束时间
 */
export const dateFormatReset = (date, isStart) => {
  date = typeof date === 'number' || typeof date === 'string' ? new Date(date) : date
  let strings = [
    '00:00:00', '23:59:59'
  ]
  let month = (date.getMonth() + 1)
  if (month < 10) {
    month = '0' + month
  }
  let day = date.getDate()
  if (day < 10) {
    day = '0' + day
  }
  let text = new Date(date.getFullYear() + '-' + month + '-' + day) + ''
  text = text.replace(/\d{2}:\d{2}:\d{2}/, ' ' + (isStart ? typeof isStart === 'string' ? isStart : strings[0] : strings[1]))
  return new Date(text).getTime()
}
/**
 * 获取本周的开始时间和结束时间
 */
export const getNowWeek = () => {
  var now = new Date()
  var day = now.getDay()
  var week = '1234560'
  var first = 0 - week.indexOf(day)
  var f = new Date()
  f.setDate(f.getDate() + first)
  var last = 6 - week.indexOf(day)
  var l = new Date()
  l.setDate(l.getDate() + last)
  return {
    begin: f,
    end: l
  }
}
/**
 * 获取本月的开始时间和结束时间
 */
export const getNowMonth = () => {
  let start = new Date()
  start.setDate(1)
  let date = new Date()
  let currentMonth = date.getMonth()
  let nextMonth = ++currentMonth
  let nextMonthFirstDay = new Date(date.getFullYear(), nextMonth, 1)
  let oneDay = 1000 * 60 * 60 * 24
  let end = new Date(nextMonthFirstDay - oneDay)
  return {
    begin: start,
    end: end
  }
}
/**
 * 获取本季度的开始时间和结束时间
 */
export const getNowQuarter = () => {
  let now = new Date()
  let nowYear = now.getYear()
  nowYear += (nowYear < 2000) ? 1900 : 0
  let nowMonth = now.getMonth()
  let quarterStartDate = new Date(nowYear, getQuarterStartMonth(nowMonth), 1)
  let quarterEndMonth = getQuarterStartMonth(nowMonth) + 2
  let monthStartDate = new Date(nowYear, nowMonth, 1)
  let monthEndDate = new Date(nowYear, nowMonth + 1, 1)
  let days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24)
  switch (quarterEndMonth + 1) {
    case 3:
    case 12:
      days = 31
      break
    case 6:
    case 9:
      days = 30
      break
    default:
      break
  }
  let quarterEndDate = new Date(nowYear, quarterEndMonth, days)
  return {
    begin: quarterStartDate,
    end: quarterEndDate
  }
}
/**
 * 获取本年的开始时间和结束时间
 */
export const getNowYear = () => {
  return {
    begin: dayjs().year(dayjs().year()).startOf('year').valueOf(),
    end: dayjs().year(dayjs().year()).endOf('year').valueOf()
  }
}

function getQuarterStartMonth (nowMonth) {
  let quarterStartMonth = 0
  if (nowMonth < 3) {
    quarterStartMonth = 0
  }
  if (nowMonth > 2 && nowMonth < 6) {
    quarterStartMonth = 3
  }
  if (nowMonth > 5 && nowMonth < 9) {
    quarterStartMonth = 6
  }
  if (nowMonth > 8) {
    quarterStartMonth = 9
  }
  return quarterStartMonth
}
/**
 * 计算年龄
 */
export const getAge = (strBirthday) => {
  let returnAge
  let strBirthdayArr = strBirthday.split('-')
  let birthYear = strBirthdayArr[0]
  let birthMonth = strBirthdayArr[1]
  let birthDay = strBirthdayArr[2]
  let d = new Date()
  let nowYear = d.getFullYear()
  let nowMonth = d.getMonth() + 1
  let nowDay = d.getDate()
  if (nowYear === parseInt(birthYear, 10)) {
    returnAge = 0
  } else {
    let ageDiff = nowYear - birthYear // 年之差
    if (ageDiff > 0) {
      if (nowMonth === birthMonth) {
        let dayDiff = nowDay - birthDay // 日之差
        if (dayDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      } else {
        let monthDiff = nowMonth - birthMonth
        if (monthDiff < 0) {
          returnAge = ageDiff - 1
        } else {
          returnAge = ageDiff
        }
      }
    } else {
      returnAge = -1
    }
  }
  return returnAge
}
// 获取总时长
export const getTimeInfo = (timestamp) => {
  let min = parseInt((timestamp) / 1000 / 60, 10)
  let hour = parseInt(min / 60, 10)
  if (hour >= 1) { // 小时
    min = min % 60
  }
  let day = parseInt(hour / 24, 10)
  if (day >= 1) { // 天
    hour = hour % 24
  }
  return (day ? `${day}天` : '') + (hour ? `${hour}小时` : '') + `${min}分钟`
}
// 数字格式
export const fixedZero = (val) => {
  return val * 1 < 10 ? `0${val}` : val
}
export const timeChange = {
  today: 'HOUR',
  yesterday: 'HOUR',
  seven: 'DAY',
  thirty: 'DAY',
  day: 'HOUR',
  yearweek: 'WEEK',
  yeardays: 'DAY',
  week: 'DAY',
  month: 'DAY',
  year: 'MONTH',
  custom: 'DAY'
}
export const timeChangeLeastDay = {
  seven: 'DAY',
  thirty: 'DAY',
  day: 'DAY',
  week: 'WEEK',
  month: 'MONTH',
  year: 'YEAR',
  custom: 'DAY'
}
// dayjs时间转换
export const getmoment = (type, timeType) => { // 当前月
  const now = new Date()
  const oneDay = 1000 * 60 * 60 * 24

  if (type === 'today') {
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    if (parseFloat(timeType) === 2) {
      return [dayjs(now).add(-1, 'y'), dayjs(now.getTime() + (oneDay - 1000)).add(-1, 'y')] // 去年同日
    } else if (parseFloat(timeType) === 1) {
      return [dayjs(now - oneDay), dayjs(now.getTime() - 1000)] // 昨天
    }
    return [dayjs(now), dayjs(now.getTime() + (oneDay - 1000))]
  }
  if (type === 'yesterday') {
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    if (parseFloat(timeType) === 2) {
      return [dayjs(now - oneDay).add(-1, 'y'), dayjs(now.getTime() - 1000).add(-1, 'y')] // 去年同日
    } else if (parseFloat(timeType) === 1) {
      return [dayjs(now - (2 * oneDay)), dayjs(now.getTime() - oneDay - 1000)] // 前天
    }
    return [dayjs(now - oneDay), dayjs(now.getTime() - 1000)]
  }

  if (type === 'week') {
    let day = now.getDay()
    now.setHours(0)
    now.setMinutes(0)
    now.setSeconds(0)
    if (day === 0) {
      day = 6
    } else {
      day -= 1
    }
    const beginTime = now.getTime() - day * oneDay // 这周第一天
    const beforeweekstart = beginTime - (7 * oneDay - 1000) // 上周第一天
    const beforeweekend = now.getTime() - (day * oneDay) - 1000

    if (parseFloat(timeType) === 2) {
      return [] // 去年同周
    } else if (parseFloat(timeType) === 1) {
      return [dayjs(beforeweekstart), dayjs(beforeweekend)] // 上周
    }
    return [dayjs(beginTime), dayjs(beginTime + (7 * oneDay - 1000))]
  }

  if (type === 'month') {
    const year = now.getFullYear()
    const month = now.getMonth()
    const nextDate = dayjs(now).add(1, 'months')
    const nextYear = nextDate.year()
    const nextMonth = nextDate.month()
    if (parseFloat(timeType) === 2) {
      return [
        dayjs(`${year - 1}-${fixedZero(month + 1)}-01 00:00:00`),
        dayjs(dayjs(`${nextYear - 1}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000)
      ] // 去年同周
    } else if (parseFloat(timeType) === 1) { // 上个月
      return [
        dayjs(`${year}-${fixedZero(month)}-01 00:00:00`),
        dayjs(dayjs(`${nextYear}-${fixedZero(nextMonth)}-01 00:00:00`).valueOf() - 1000)]
    }
    return [
      dayjs(`${year}-${fixedZero(month + 1)}-01 00:00:00`),
      dayjs(dayjs(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000)
    ]
  }

  if (type === 'year') {
    const year = now.getFullYear()
    if (parseFloat(timeType) === 2) {
      return [dayjs(`${year - 1}-01-01 00:00:00`), dayjs(`${year - 1}-12-31 23:59:59`)] // 昨年
    } else if (parseFloat(timeType) === 1) {
      return [dayjs(`${year - 1}-01-01 00:00:00`), dayjs(`${year - 1}-12-31 23:59:59`)] // 昨年
    }
    return [dayjs(`${year}-01-01 00:00:00`), dayjs(`${year}-12-31 23:59:59`)]
  }
}

export const getareatime = (startTime, endTime) => { // 相隔天数
  const oneDay = 1000 * 60 * 60 * 24
  let start = dayjs(startTime).valueOf()
  let end = dayjs(endTime).valueOf()
  let durty = Math.ceil((end - start) / oneDay)
  return durty
}

export const ABS = (first, second, isPercent = false) => { // 之前数据百分比
  if (isPercent) {
    return Math.abs(((parseFloat(first) - parseFloat(second)) * 100)).toFixed(1) + '%'
  } else {
    if (parseFloat(second) === 0) {
      return '--'
    } else {
      return (Math.abs((parseFloat(first) - parseFloat(second)) / (parseFloat(second))) * 100).toFixed(1) + '%'
    }
  }
}

export const UPDOWN = (first, second, isPercent = false) => { // 上升下降图标
  if (isPercent) {
    if (parseFloat(first) - parseFloat(second) === 0) {
      return ''
    } else {
      return parseFloat(first) - parseFloat(second) > 0 ? <CaretUpOutlined style={{ color: '#FF5353' }} /> : <CaretDownOutlined style={{ color: '#54CD85' }} />
    }
  } else {
    if (parseFloat(second) === 0) {
      return ''
    } else {
      return parseFloat(first) - parseFloat(second) > 0 ? <CaretUpOutlined style={{ color: '#FF5353' }} /> : <CaretDownOutlined style={{ color: '#54CD85' }} />
    }
  }
}

export const PERCENT = (value) => { // 转化为百分数
  return (parseFloat(value) * 100).toFixed(2) + '%'
}

// 返回值：arg1加上arg2的精确结果
export const accAdd = (arg1, arg2) => {
  var r1, r2, m
  if (!arg2) {
    return arg1
  }
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  };
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  };
  m = Math.pow(10, Math.max(r1, r2))
  return (arg1 * m + arg2 * m) / m
}

// 返回值：arg1减去arg2的精确结果
export const accSub = (arg1, arg2) => {
  var r1, r2, m, n
  if (!arg2) {
    return arg1
  }
  try {
    r1 = arg1.toString().split('.')[1].length
  } catch (e) {
    r1 = 0
  };
  try {
    r2 = arg2.toString().split('.')[1].length
  } catch (e) {
    r2 = 0
  };
  m = Math.pow(10, Math.max(r1, r2))
  // 动态控制精度长度
  n = (r1 >= r2) ? r1 : r2
  return ((arg1 * m - arg2 * m) / m).toFixed(n)
}

/**
 * @param date 202008
 * @param timeType 时间类型
 * @param yearType 年份类型
 * 202008 转换成 2020-08
 */
export const timeTransToDate = (date, timeType, yearType) => {
  const switchType = {
    seven: 'days',
    thirty: 'days',
    day: 'hours',
    week: 'days',
    month: 'days',
    year: 'month',
    custom: 'days'
  }
  if (switchType[timeType] === 'days') {
    return dayjs(date).format('YYYY-MM-DD')
  } else if (switchType[timeType] === 'hours') {
    return dayjs(date.slice(0, -2)).format('YYYY-MM-DD') + ` ${date.slice(-2)}`
  } else if (switchType[timeType] === 'month') {
    if (yearType === 'yearweek') {
      return date
    } else if (yearType === 'yeardays') {
      return dayjs(date).format('YYYY-MM-DD')
    } else {
      return date.slice(0, 4) + '-' + date.slice(4)
    }
  } else {
    return date
  }
}

/**
 * @param startDate 开始日期
 * @param endData 结束日期
 * @param timeType 时间类型
 * @param yearType 自然年类型
 * 日期转换成时间戳
 */
export const dateTransToTemp = (startDate, endData, yearType, timeType) => {
  const switchType = {
    seven: 'days',
    thirty: 'days',
    day: 'hours',
    week: 'days',
    month: 'days',
    year: 'month',
    custom: 'days'
  }
  let startTimeTemp, endTimeTemp
  if (switchType[timeType] === 'days') {
    startTimeTemp = dayjs(startDate).startOf('day').valueOf()
    endTimeTemp = dayjs(endData).endOf('day').valueOf()
  } else if (switchType[timeType] === 'hours') {
    startTimeTemp = dayjs(`${startDate}:00:00`).valueOf()
    endTimeTemp = dayjs(`${endData}:59:59`).valueOf()
  } else if (switchType[timeType] === 'month') {
    if (yearType === 'yeardays') {
      startTimeTemp = dayjs(startDate).startOf('day').valueOf()
      endTimeTemp = dayjs(endData).endOf('day').valueOf()
    } else if (yearType === 'yearweek') {
      startTimeTemp = dayjs(startDate.slice(0, 4)).week(Number(startDate.slice(-2))).startOf('week').valueOf()
      endTimeTemp = dayjs(endData.slice(0, 4)).week(Number(endData.slice(-2))).startOf('week').valueOf()
    } else {
      startTimeTemp = dayjs(startDate).startOf('month').valueOf()
      endTimeTemp = dayjs(endData).endOf('month').valueOf()
    }
  }
  return [startTimeTemp, endTimeTemp]
}

/**
 * @param durationTemp 差值时间戳
 * 计算时间差  以天为最大单位  小于1分钟返回'<1分钟'
 */
export const endDiffStart = (durationTemp) => {
  let dur = dayjs.duration(durationTemp)
  let { hours, minutes } = dur._data
  let days = parseInt(dur.as('days'), 10)
  let isLessThanOneMinute = (days === 0) && (hours === 0) && (minutes === 0)
  let result = intl.get('utils.comma') + intl.get('utils.timeActuallyTook') + (days > 0 ? intl.get('utils.d', { d: days }) : '') + (hours > 0 ? intl.get('utils.h', { h: hours }) : '') + (minutes > 0 ? intl.get('utils.m', { m: minutes }) : '')

  if (isLessThanOneMinute) {
    return intl.get('utils.comma') + intl.get('utils.timeActuallyTook') + intl.get('utils.underOneM')
  } else {
    return result
  }
}

// 判断是否是ie浏览器
export const isIE = () => {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true
  } else {
    return false
  }
}
// base64下载图片
export const base64download = (base64, name = 'download') => {
  // 这里是获取到的图片base64编码,这里只是个例子哈，要自行编码图片替换这里才能测试看到效果
  const imgUrl = base64
  // 如果浏览器支持msSaveOrOpenBlob方法（也就是使用IE浏览器的时候），那么调用该方法去下载图片
  if (window.navigator.msSaveOrOpenBlob) {
    var bstr = atob(imgUrl.split(',')[1])
    var n = bstr.length
    var u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    var blob = new Blob([u8arr])
    window.navigator.msSaveOrOpenBlob(blob, name + '.png')
  } else {
    // 这里就按照chrome等新版浏览器来处理
    const a = document.createElement('a')
    a.href = imgUrl
    a.setAttribute('download', name)
    a.click()
    // 如果在firefox下报错, 使用下面这句下载
    // a.initEvent('click', false, false);
  }
}

// url下载图片
export const downloadIamge = (imgsrc, name) => { // 下载图片地址和图片名
  let image = new Image()
  // 解决跨域 Canvas 污染问题
  image.setAttribute('crossOrigin', 'anonymous')
  image.onload = function () {
    let canvas = document.createElement('canvas')
    canvas.width = image.width
    canvas.height = image.height
    let context = canvas.getContext('2d')
    context.drawImage(image, 0, 0, image.width, image.height)
    let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
    let a = document.createElement('a') // 生成一个a元素
    let event = new MouseEvent('click') // 创建一个单击事件
    a.download = name || 'image' // 设置图片名称
    a.href = url // 将生成的URL设置为a.href属性
    a.dispatchEvent(event) // 触发a的单击事件
  }
  image.src = imgsrc
}

/**
 * 通过人员信息的部门Id把人员添加到对应部门下面
 * @param userList 人员列表
 * @param departmentList 部门列表
 * @returns {[]} 人员按部门分配在部门列表下面
 */

export const getDepartmentUserList = (userList = [], departmentList = []) => {
  const reportRecursion = (departmentList) => {
    for (let value of departmentList) {
      value.selectable = false
      for (let item of userList) {
        item.selectable = true
        if (value.id === item.departmentId) {
          if (!value.children) {
            value.children = []
            value.isLeaf = false
            value.children.push(item)
          } else {
            value.children.push(item)
          }
        }
      }
      if (value.children) {
        reportRecursion(value.children)
      }
    }
  }
  reportRecursion(departmentList)
  const addNoDepartment = (allData, staffOrReport) => {
    for (let item of staffOrReport) {
      if (item.departmentId === null) {
        item.isLeaf = true
        item.selectable = true
        allData.push(item)
      }
    }
  }
  addNoDepartment(departmentList, userList)
  return departmentList
}

/**
 * 带设备验证的弹窗
 * @param content 弹窗内容
 * @returns Modal
 */

export const appModal = () => {
  let content = intl.get('utils.noInstallationPackageToDownloadPleaseContactAdministrator')
  Modal.warning({
    content,
    okText: intl.get('utils.Confirm'),
    className: 'app-download-url-not-exist-modal'
  })
}

// 内联样式中的px转为rem
export const px2rem = (px) => {
  const BASE_FONT_SIZE = 16 // 基准字号，与根元素的 font-size 保持一致
  return `${px / BASE_FONT_SIZE}rem`
}

// rem反向转px
export const rem2px = (rem) => {
  if (rem) {
    const num = parseFloat(rem.replace('rem', ''))
    const BASE_FONT_SIZE = 16 // 基准字号，与根元素的 font-size 保持一致
    return num * BASE_FONT_SIZE
  }
}

// 根据默认字体大小(根节点font-size)做兼容适配，如果根节点font-size没更新，则不更新比例
export const getScale = () => {
  let curFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize)
  let scale = curFontSize / 16
  return scale
}

// 获取当前屏幕显示分辨率和基准分辨率比
export const realScale = () => {
  let newScale = 1

  if (!(window.screen.width < 768)) {
    // 设计图宽690 放在1920屏幕中太小 默认放大1.5倍
    newScale = 1
    let windowScale = document.documentElement.clientWidth / 1920 || 1
    if (windowScale > 1) {
      windowScale = 1
    }
    newScale *= windowScale
  }
  return newScale
}

export const Origin = () => {
  if (isIE()) {
    return window.location.protocol + '//' + window.location.hostname + (window.location.port ? ':' + window.location.port : '')
  } else {
    return window.location.origin
  }
}

/**
 * @desc 切换语言
 */
export const changeLangApi = () => {
  return new Promise((resolve) => {
    let currentLang = localStorage.getItem('lang') || 'zh-CN'
    changeLanguage({
      language: currentLang.replace('-', '_')
    }).then(() => {
      resolve()
    })
  })
}

// 登录后状态存储、跳转
export const loginSuccess = async (data) => {
  user.update(data) // 存储user信息到localStorage和redux
  login.login() // 更新登录状态
  await changeLangApi() // 存储当前语言
  if (data?.enterprise?.grayId) {
    window.location.href = `${Origin()}/${data.enterprise.nameMap[data.enterprise.grayId]}/`
  }
}
